import { IReferenceType, IOpObject } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { OpDescr } from './op-descr'
import { OpDeviceTypeData } from './op-device-type-data'
import { OpDataList } from '../util'
import { Utils } from '../util/utils'
import { OpDeviceTypeClass } from './op-device-type-class'

export class OpDeviceType implements IReferenceType, IOpObject {
    public idDeviceType: number
    public name: string
    public idDescr: number
    public idDeviceTypeClass: number
    
    constructor(opObj: any) {
        this.fromJSON(opObj)
    }
    
    //#region Navigation properties
    
    public descr: OpDescr
    public deviceTypeClass: OpDeviceTypeClass
    
    //#endregion

    // #region IOpObject implementation

    public get idObject(): any { return this.idDeviceType }
    public set idObject(value: any) { this.idDeviceType = value }

    public dataList: OpDataList<OpDeviceTypeData> = new OpDataList(OpDeviceTypeData)
    public dynamicValues: { Key: string, Value: any }[]
    public customFormatString: string

    // #endregion

    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion

    // #region IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdDeviceType
    }
    public getReferenceKey(): number {
        return this.idDeviceType
    }
    public getReferenceValue(): any {
        return this
    }

    // #endregion

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {

            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {

                this.idDeviceType = opObj.I
                this.name = opObj.N
                this.idDescr = opObj.ID
                this.descr = opObj.D != null ? new OpDescr(opObj.D) : null
                this.idDeviceTypeClass = opObj.IDT

                if (opObj.DL != null) {
                    if (this.dataList == null) {
                        this.dataList = new OpDataList(OpDeviceTypeData)
                    }

                    this.dataList.push(...opObj.DL.map((dItem: any) => new OpDeviceTypeData(dItem)))
                }

                this.opState = opObj.O

            } else {

                this.idDeviceType = opObj.ID_DEVICE_TYPE
                this.name = opObj.NAME
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.idDeviceTypeClass = opObj.ID_DEVICE_TYPE_CLASS

                if (opObj.DataList != null) {
                    this.dataList.push(...opObj.DataList.map(data => new OpDeviceTypeData(data)))
                }

                this.opState = opObj.OpState
            }
        }
    }

    public toJSON(compressed: boolean = false): any {

        if (compressed) {
            return {

                I: this.idDeviceType,
                N: this.name,
                ID: this.idDescr,
                D: this.descr != null ? this.descr.toJSON() : null,
                O: this.opState,
                DL: this.dataList == null ? null : this.dataList.ToJSON(),
                IDT: this.idDeviceTypeClass,

                __IC: 1
            }
        } else {
            return {
                ID_DEVICE_TYPE: this.idDeviceType,
                NAME: this.name,
                ID_DESCR: this.idDescr,
                _Descr: this.descr != null ? this.descr.toJSON() : null,
                DataList: this.dataList == null ? null : this.dataList.ToJSON(),
                OpState: this.opState,
                ID_DEVICE_TYPE_CLASS: this.idDeviceTypeClass
            }
        }
    }

    public toString(): string {
        if (this.descr != null) {
            return this.descr.description
        }

        return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDeviceType[]): JQueryPromise<OpDeviceType[]> {
        return Utils.loadDataListNavigationProperties(dataProvider, list)
    }
}